import { translate } from '@cashfree-intl/coherent';
import * as Yup from 'yup';

export const validate = () => values => {
  const errors = {};

  let totalPercentage = 0;
  values.scheme.forEach(item => {
    if (Number(item.percentage) > 100) {
      totalPercentage = 0;
      return;
    }
    totalPercentage += Number(item.percentage);
  });

  if (values.terminalRefIdSearch && values.terminalId === '') {
    errors.terminalRefIdSearch = `${translate('reference_id_does_not_exist')}`;
  } else if (values.referenceIdExists) {
    errors.terminalRefIdSearch = `${translate(
      'fixed_split_for_the_reference_id_already_exists',
    )}`;
  }

  if (totalPercentage > 100) {
    errors.totalPercentage = `${translate(
      'total_split_percentage_cannot_be_greater_than_100',
    )}`;
  } else if (values.scheme.length > 0) {
    // if values.scheme.merchantVendorId has duplicate values
    let duplicatesExist = false;
    const alreadySeen = {};
    values.scheme.forEach(({ merchantVendorId }) => {
      if (alreadySeen[merchantVendorId]) duplicatesExist = true;
      else if (merchantVendorId !== '') alreadySeen[merchantVendorId] = true;
    });
    if (duplicatesExist)
      errors.duplicatesExist = `${translate(
        'duplicate_merchant_vendor_ids_are_not_allowed',
      )}`;

    values.vendorIdErrorList.forEach(element => {
      if (element !== '')
        errors.vendorError = `${translate('enter_a_valid_vendor_id')}`;
    });
  }
  return errors;
};

const validationSchema = Yup.object({
  productType: Yup.string().required(),
  active: Yup.boolean().required(),
  commissionPercentage: Yup.number().when(
    ['productType', 'active'],
    (productType, active, schema) => {
      if (active && (productType === 'EPOS' || productType === 'STATIC_QR')) {
        return schema
          .positive(
            `${translate('enter_a_valid_percentage_between_0_and_100')}`,
          )
          .required(`${translate('this_is_a_required_field')}`)
          .typeError(
            `${translate('enter_a_valid_percentage_between_0_and_100')}`,
          );
      }
      return schema;
    },
  ),

  terminalRefIdSearch: Yup.string().when(
    ['productType'],
    (productType, schema) => {
      if (productType === 'SBC') {
        return schema.required(`${translate('this_is_a_required_field')}`);
      }
      return schema;
    },
  ),

  scheme: Yup.array().when(
    ['productType', 'active'],
    (productType, active, schema) => {
      if (active && (productType === 'PG' || productType === 'SBC')) {
        return schema.of(
          Yup.object().shape({
            merchantVendorId: Yup.string().required(
              `${translate('this_is_a_required_field')}`,
            ),
            percentage: Yup.number()
              .integer(`${translate('enter_a_valid_percentage_value')}`)
              .positive(`${translate('split_percentage_cannot_be_negative')}`)
              .required(`${translate('this_is_a_required_field')}`)
              .typeError(`${translate('enter_a_valid_percentage_value')}`)
              .min(1, `${translate('split_percentage_cannot_be_0')}`)
              .max(100, `${translate('enter_a_value_lesser_than_100')}`),
          }),
        );
      }
      return schema;
    },
  ),
});

export default validationSchema;
